
import { Component, Vue} from 'vue-property-decorator';

@Component
export default class EndCircleSvgChecked extends Vue {

}
